<template>
  <div class="notes-activity-container">
    <!-- Házifeladat Section -->
    <div class="info-card">
      <div class="card-header">
        <div class="card-icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
            <polyline points="14,2 14,8 20,8"/>
            <line x1="16" y1="13" x2="8" y2="13"/>
            <line x1="16" y1="17" x2="8" y2="17"/>
          </svg>
        </div>
        <h3>Házifeladat</h3>
      </div>
      
      <div class="info-list">
        <div class="info-item">
          <div class="info-value homework-content">
            <p v-if="homework" class="mb-0">{{ homework }}</p>
            <p v-else class="no-homework mb-0">Nincs házifeladat megadva.</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Visszajelzés Section -->
    <div v-if="childInfo && childInfo.childGrpId && childInfo.childGrpId.Valid && !isAdmin && !isTeacher" class="info-card">
      <div class="card-header">
        <div class="card-icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
          </svg>
        </div>
        <h3>Visszajelzés</h3>
      </div>
      
      <div class="info-list">
        <div class="info-item">
          <div class="info-label">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M9 12l2 2 4-4"/>
            </svg>
            Részvétel
          </div>
          <div class="info-value">
            <p class="response-description mb-2">Jelezd vissza, hogy részt veszel a táncórán</p>
            <button class="modern-btn modern-btn--primary btn-sm" @click="$emit('get-hash', 'cresp')">
              Visszajelzés
            </button>
          </div>
        </div>

        <div class="info-item" v-if="!isDancerRoute">
          <div class="info-label">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
            </svg>
            Táncos leadása
          </div>
          <div class="info-value">
            <p class="response-description mb-2">Jelezd, hogy leadod a táncost a táncórára</p>
            <button class="modern-btn modern-btn--success btn-sm" @click="$emit('get-hash', 'cdrof')">
              Leadás
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Aktivítás Section -->
    <div v-if="isAdmin && childInfo && childInfo.status" class="info-card">
      <div class="card-header">
        <div class="card-icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M9 12l2 2 4-4"/>
            <path d="M21 12c-1 0-3-1-3-3s2-3 3-3 3 1 3 3-2 3-3 3"/>
          </svg>
        </div>
        <h3>Aktivítás</h3>
      </div>
      
      <div class="info-list">
        <div class="info-item">
          <div class="info-label">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M9 12l2 2 4-4"/>
            </svg>
            Állapot
          </div>
          <div class="info-value">
            <select v-model="childInfo.status.String" @change="$emit('update-active-status', childInfo.status.String)" class="modern-select">
              <option value="Inactive">Inaktív</option>
              <option value="Active">Aktív</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChildNotesActivity',
  props: {
    homework: {
      type: String,
      default: ''
    },
    childInfo: {
      type: Object,
      default: null
    },
    isAdmin: {
      type: Boolean,
      default: false
    },
    isTeacher: {
      type: Boolean,
      default: false
    },
    isDancerRoute: {
      type: Boolean,
      default: false
    }
  },
  emits: ['get-hash', 'update-active-status']
};
</script>

<style scoped>
.notes-activity-container {
  display: contents;
}

.info-card {
  background: var(--card-bg);
  border-radius: 16px;
  box-shadow: var(--shadow);
  overflow: hidden;
  border: 1px solid var(--color-border);
}

.card-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.5rem 2rem;
  background: var(--color-background-soft);
  border-bottom: 1px solid var(--color-border);
}

.card-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  background: var(--button-primary, #2563eb);
  border-radius: 12px;
  color: white;
}

.card-header h3 {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--color-text);
}

.info-list {
  padding: 1.5rem 2rem;
}

.info-item {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  padding: 1rem 0;
  border-bottom: 1px solid var(--color-border);
}

.info-item:last-child {
  border-bottom: none;
}

.info-label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  min-width: 140px;
  font-weight: 600;
  color: var(--color-text);
}

.info-label svg {
  color: var(--button-primary, #2563eb);
  flex-shrink: 0;
}

.info-value {
  flex: 1;
  color: var(--color-text-muted);
  word-break: break-word;
}

.no-homework {
  color: var(--color-text-muted);
  font-style: italic;
}

.response-description {
  color: var(--color-text-muted);
  font-size: 0.875rem;
}
</style>
